// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 792 ? "main" : chunkId) + "." + {"449":"66e8acfe00deb4e2087b","792":"6898aad225df8098490b"}[chunkId] + ".css";
};